import { render, staticRenderFns } from "./form-indicators.vue?vue&type=template&id=18a6c764&scoped=true"
import script from "./form-indicators.vue?vue&type=script&lang=js"
export * from "./form-indicators.vue?vue&type=script&lang=js"
import style0 from "./form-indicators.vue?vue&type=style&index=0&id=18a6c764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a6c764",
  null
  
)

export default component.exports